import CircularProgress from '@mui/material/CircularProgress';
import './style.scss';
import Backdrop from '@mui/material/Backdrop';

type Tprop = {
    loaderMessage?: string,
    loader: boolean
}

const Loader: React.FC<Tprop> = ({ loaderMessage, loader }) => {
    return (

        <div className='loader'>
            <Backdrop sx={{ color: '#fff', backgroundColor: `${loaderMessage ? '#000000c2' : 'unset'}`, zIndex: 2 }} open={loader}>
                <CircularProgress color="primary" sx={{ marginRight: 2 }} />
                <p className='loader-message'>{loaderMessage}</p>
            </Backdrop>
        </div>
    )
}

export default Loader